package fr.manyverse.app

import co.touchlab.kermit.Logger
import kotlinx.coroutines.CancellationException

/**
 * Point d'entrée unique des logs de l'app, adossé à Kermit.
 *
 * Kermit écrit dans la sortie native de chaque plateforme (Logcat, OSLog, console du
 * navigateur, stdout sur desktop). Les writers supplémentaires — celui qui alimente Sentry
 * notamment — sont branchés par `initMonitoring()` au démarrage.
 */
object AppLogger {
    fun error(tag: String, message: String, throwable: Throwable? = null) {
        // Une annulation de coroutine fait partie du cycle de vie normal, ce n'est pas une erreur
        if (throwable is CancellationException) return
        Logger.e(message, throwable, tag)
    }

    fun warn(tag: String, message: String) {
        Logger.w(message, tag = tag)
    }

    fun debug(tag: String, message: String) {
        Logger.d(message, tag = tag)
    }

    fun info(tag: String, message: String) {
        Logger.i(message, tag = tag)
    }
}
